const host = "https://firstcrymockserver2.onrender.com"
export const  Menkids =  host + "/MenKids";
export const  Girlkids =  host + "/GirlKids";
export const Footwearurl = host + "/Footwear";
export const clublogo = "https://cdn.fcglcdn.com/brainbees/images/club_flag_listing_desktop.png";
export const clublogobig = "https://cdn.fcglcdn.com/brainbees/images/pdpcl_club_logo_desktop.jpg";
export const Exclusiveoffer = "https://cdn.fcglcdn.com/brainbees/images/club_member.webp";
export const lowerprice = "https://cdn.fcglcdn.com/brainbees/images/price_benefit_member.webp";
export const loyaltycash = "https://cdn.fcglcdn.com/brainbees/images/earn_loyalty_cash.webp";
export const freebabygear = "https://cdn.fcglcdn.com/brainbees/images/baby_gear_assembly.webp";
export const Lowershipping = "https://cdn.fcglcdn.com/brainbees/images/lower_shipping_barrier.webp";
export const loadinggif = "https://media.tenor.com/I6kN-6X7nhAAAAAj/loading-buffering.gif";